"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSCodeExtensionContext = void 0;
const IVSCodeExtensionContext_1 = require("./IVSCodeExtensionContext");
const vscode = require("vscode");
class VSCodeExtensionContext extends IVSCodeExtensionContext_1.IVSCodeExtensionContext {
    constructor(trueContext) {
        super();
        this.context = trueContext;
    }
    setVSCodeEnvironmentVariable(variable, value) {
        const environment = this.context.environmentVariableCollection;
        environment.replace(variable, value);
    }
    appendToEnvironmentVariable(variable, appendingValue) {
        const environment = this.context.environmentVariableCollection;
        environment === null || environment === void 0 ? void 0 : environment.append(variable, appendingValue);
    }
    registerOnExtensionChange(f, ...args) {
        vscode.extensions.onDidChange(() => {
            f(...(args));
        });
    }
    getExtensions() {
        return vscode.extensions.all;
    }
    executeCommand(command, ...args) {
        return vscode.commands.executeCommand(command, ...args);
    }
}
exports.VSCodeExtensionContext = VSCodeExtensionContext;
//# sourceMappingURL=VSCodeExtensionContext.js.map